// extracted by mini-css-extract-plugin
export default {"profileWrapper":"Profile_profileWrapper__3qEQu","profilePic":"Profile_profilePic__kPnBv","badge":"Profile_badge__84ips","badges":"Profile_badges__UScV9"};